import { FormValidateInput } from '@mantine/form';
import { PropsWithChildren } from 'react';

import { FormProvider, useForm } from './form-context';

type Props<T> = {
  initialValues: Partial<T>;
  validate?: FormValidateInput<T>;
  onSubmit?: (values: T) => void | Promise<unknown>;
  onError?: (errors: Record<string, unknown>) => void;
  loading?: boolean;
};

export const Form = <T,>({
  children,
  initialValues,
  validate,
  onSubmit,
  onError,
  loading = false,
}: PropsWithChildren<Props<T>>) => {
  const form = useForm({
    initialValues,
    validate: validate as FormValidateInput<unknown>,
  });

  const handleSubmit = async (values: unknown) => {
    try {
      await onSubmit?.(values as T);
    } catch (error) {
      console.error('Form submission error:', error);
      onError?.(form.errors);
    }
  };

  return (
    <FormProvider form={form}>
      <form
        onSubmit={form.onSubmit(handleSubmit)}
        style={{ height: '100%', pointerEvents: loading ? 'none' : 'auto' }}
      >
        {children}
      </form>
    </FormProvider>
  );
};
